import styled, { css } from 'styled-components';
import illustrationBackgroundMap from '@assets/illustrations/empty-state-map-background.svg';
import DistanceIcon from '@assets/svg/distanceIconWhite.svg';

export const Content = styled.section`
  ${({ theme }) => css`
    background-image: url(${illustrationBackgroundMap});
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-radius: ${theme.spacing.km3};
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacing.km4};
    width: 90%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: ${theme.color.background.neutral.default};
    border-radius: ${theme.spacing.km3};
    gap: ${theme.spacing.km2};
  `}
`;

export const DistanceWhiteIcon = styled.img.attrs({
  src: DistanceIcon,
})``;
